import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/40/thumb-landscape.jpg"

const Post40 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">LOEWE／パズルバッグ／28 x17 x12cm</span>  
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>極上のレザーと複雑なパーツを組み合わせたユニークな構造で人気のLOEWE（ロエベ）の「パズル バッグ」。超コンパクトな「ナノ」サイズも登場し、ロエベのアイコンバッグとなっています。<br></br>今回は、「パズル バッグ」の5つのサイズ、コーディネート、人気の秘密について詳しくご紹介していきます。
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2>目次</h2>
        <p>
          <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80}>①LOEWE（ロエベ）とは</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80}>②「パズル バッグ」ってどんなバッグ？</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec3" smooth={true} duration={500} offset={-80}>③5wayの持ち方とは？</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec4" smooth={true} duration={500} offset={-80}>④5つのサイズ展開</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec5" smooth={true} duration={500} offset={-80}>⑤人気カラー、サイズは？</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec6" smooth={true} duration={500} offset={-80}>⑥まとめ</ScrollLink>
        </p>
      </div>         
      <figure>
        <StaticImage src="../../images/posts/40/1.jpg" alt="ジェンダーレスでユニークなデザインが特徴！LOEWE（ロエベ）「パズル バッグ」とは？"/>
        <span className="text-center">LOEWE／パズルスモールバッグ／23 x16 x10cm</span>  
      </figure>    
      <div name="sec1" className="text-two-cloumn">
        <h2>①LOEWE（ロエベ）とは？</h2>
        <p>
          LOEWE（ロエベ）は1846年にスペインの皮革職人が数人でマドリードに立ち上げたレザーグッズを取り扱う工房を立ち上げたのが始まりです。当時から独創的で高い品質を誇るロエベ製品が気に入られ、スペイン王室御用達の称号を授かります。<br></br>2013年からは、自身のブランド、JW ANDERSONも好調なジョナサン・アンダーソンをクリエイティブ・ディレクターへ迎えこれまでのブランドロゴを刷新し、新生ロエベをスタートさせています。
        </p>
      </div>
      <div name="sec2" className="text-two-cloumn">
        <h2>②「パズル バッグ」って<br className="pc"></br>どんなバッグ？</h2>       
        <p>「パズル バッグ」は、現クリエイティブ・ディレクターのジョナサン・アンダーソンがロエベで初めてデザインした日本の折り紙からインスピレーションを受けて生まれたバッグなんです。レザーパーツをまるでパズルのように組み合わせた構築的フォルムが特徴のバッグで、バッグ自体も折リ紙のようにフラットにも折りたためます。また5Wayで使える多様性の高さから、使ってこそ真価を発揮できるバックとして多くの人から愛されているバッグです。
        </p>
      </div> 
      <figure>
        <StaticImage src="../../images/posts/40/2.jpg" alt=""/>
        <span className="text-center">
          奥から順に<br></br>
          LOEWE／パズルバッグミニ／17 x11 x7cm<br></br>
          LOEWE／パズルバッグナノ／12 x8 x5cm<br></br>
          LOEWE／パズルバッグナノ／12 x8 x5cm
        </span>  
      </figure>               
      <div name="sec3" className="text-two-cloumn">
        <h2>③5wayの持ち方とは？</h2>
        <p>
          トップハンドルと取り外し可能なショルダーストラップが付いているので、下記のような5通りの持ち方が可能です。（※写真のバッグサイズはミディアム）
        </p>
      </div>
      <div className="text-max-width">
        <h2>1.ハンドバッグ</h2>
        <p>手持ちでエレガントにハンドバッグとして。</p></div>                
      <figure>
        <StaticImage src="../../images/posts/40/3.jpg" alt=""/>
        <span className="text-center">LOEWE／パズルバッグ／28 x17 x12cm</span>  
      </figure>
      <div className="text-max-width">
        <h2>2.ショルダーバッグ</h2>
        <p>肩掛けショルダー、お仕事にも。</p>
      </div>    
      <figure>
        <StaticImage src="../../images/posts/40/4.jpg" alt=""/>
        <span className="text-center">LOEWE／パズルバッグ／28 x17 x12cm</span>  
      </figure>
      <div className="text-max-width">
        <h2>3.メッセンジャーバッグ</h2>
        <p>斜め掛けして、旅行やショッピングに。</p>
      </div>           
      <figure>
        <StaticImage src="../../images/posts/40/5.jpg" alt=""/>
        <span className="text-center">LOEWE／パズルバッグ／28 x19 x11cm</span>  
      </figure>
      <div className="text-max-width">
        <h2>4.ボディバッグ</h2>
        <p>休日にカジュアルに持ちたい時は、ボディバッグで。</p>
      </div>           
      <figure>
        <StaticImage src="../../images/posts/40/6.jpg" alt=""/>
        <span className="text-center">LOEWE／パズルバッグ／28 x19 x11cm</span>  
      </figure>
      <div className="text-max-width">
        <h2>5.クラッチバッグ</h2>
        <p>掴み持ちも、もちろん可能！とってもやわらかいレザーですので、持ち方次第で表情が変わります。コーディネートの幅が広がりますね！</p>
      </div>          
      <figure>
        <StaticImage src="../../images/posts/40/7.jpg" alt=""/>
        <span className="text-center">LOEWE／パズルバッグ／28 x17 x12cm</span>  
      </figure>                              
      <Link to="https://laxus.co/app/pc/bags/loewe" className="view-all-button">
       LOEWEのバッグを見る
      </Link>
      <div name="sec4" className="text-max-width">
        <h2>④5つのサイズ展開</h2>
      </div>    
      <h2>1.ラージ /38x22x20cm(幅x高さxマチ)</h2>
      <p>A4サイズも収納できるラージサイズ。荷物が多い日もかっこよく決まります。ショルダーストラップをつけてちょっとした出張や旅行にも行けそうなサイズ感です。</p>
        <figure className="img-small">
          <StaticImage src="../../images/posts/40/8.png" alt=""/>
        </figure>
      <div className="img-two-cloumn">      
        <figure className="img-small">
          <StaticImage src="../../images/posts/40/9.jpg" alt=""/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/40/10.jpg" alt=""/>
        </figure>        
      </div>
      <div className="text-max-width">
        <h2>2.ミディアム /28x17x12cm(幅x高さxマチ)</h2>
        <p>一番人気のサイズ、ミディアムは日常使いからビジネススタイルまで幅広く活躍するサイズ感。休みの日に、荷物を入れ替えるのが面倒！という方にもおすすめです。ストラップで変化をつけてオンもオフもこれ一つで過ごせます。</p></div>
      <figure>
        <StaticImage src="../../images/posts/40/11.jpg" alt=""/>
      </figure>
      <div className="text-max-width">
        <h2>3.スモール /23x15x10cm(幅x高さxマチ)</h2>
        <p>人気のミディアムサイズでも少し大きいと感じる、小柄な方にはスモールがおすすめ。</p>
      </div>
      <figure>
        <StaticImage src="../../images/posts/40/12.jpg" alt=""/>
      </figure>
      <div className="text-max-width">
        <h2>4.ミニパズルバッグ /17x12x7cm(幅x高さxマチ)</h2>
        <p>スモールよりもさらにコンパクトなミニ。横にするとギリギリ、スマホが入る大きさ。ワンマイルコーデのポイントにしても◎</p></div> 
      <figure>
        <StaticImage src="../../images/posts/40/13.jpg" alt=""/>
      </figure>
      <div className="text-max-width">
        <h2>5.パズルバッグナノ /12x8x5cm(幅x高さxマチ)</h2>
        <p>手のひらサイズのナノは本当にコンパクト。残念ながら、スマホは入りません。カラフルなカラー展開と小ささが可愛いのでアクセサリーバッグとして。</p>
      </div>
      <div className="img-two-cloumn">      
        <figure>
          <StaticImage src="../../images/posts/40/14.jpg" alt=""/>
        </figure>
        <figure>
          <StaticImage src="../../images/posts/40/15.jpg" alt=""/>
        </figure>        
      </div>
      <figure>
        <StaticImage src="../../images/posts/40/16.jpg" alt=""/>
      </figure>
      <div name="sec5" className="text-two-cloumn">
        <h2>⑤人気カラー、サイズは？</h2>
        <p>人気カラーの1位は「タン」。サイズ展開問わずに人気のカラーですが、ミディアムサイズは特に人気です！やわらかいレザーの質感がさらにこのカラーを引き立てます。</p>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/40/17.png" alt=""/>
        <span className="text-center">LOEWE／パズルバッグ／28 x17 x12cm</span>  
      </figure>
      <p className="text-max-width">休日には同系色のコーデもかわいい♡</p>      
      <figure className="img-small">
        <StaticImage src="../../images/posts/40/18.png" alt=""/>
      </figure>
      <p className="text-max-width">
        ミニ、ナノはカラーバッグがおすすめ！バッグがコンパクトだとよりカラーアイテムが映えてかわいいですよね。トレンドのグリーンをアクセサリー感覚でポイントにしても◎
      </p>
      <figure className="img-small">
        <StaticImage src="../../images/posts/40/19.png" alt=""/>
        <span className="text-center">LOEWE／パズルバッグミニ／17 x12 x7cm</span>  
      </figure>
      <div name="sec6" className="text-two-cloumn">
        <h2>⑥まとめ</h2>
        <p>
          いかがでしたでしょうか？<br></br>「パズル バッグ」はサイズ、種類ともに豊富です。やわらかくて軽い質感をまずは実際に手にとって体験して見てください。きっとあなたのワードローブを豊かにしてくれることでしょう。
        </p>
      </div>
      <Link to="https://laxus.co/app/pc/bags/loewe" className="view-all-button">
       LOEWEのバッグを見る
      </Link>
    </section>
    <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post40

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 40}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
